
import { upcomingEvents } from '../../../mocks/events';

export default function UpcomingEvents() {
  const handleLearnMore = () => {
    window.REACT_APP_NAVIGATE('/events');
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-warrior-black mb-4">
            Upcoming Events
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Stay connected with our community through exciting camps, clinics, and fundraising events throughout the year.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {upcomingEvents.map((event) => (
            <div
              key={event.id}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col"
            >
              <div className="relative w-full h-56">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-warrior-red text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  {event.dateLabel}
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-calendar-line text-warrior-red text-xl"></i>
                  <span className="text-gray-600 text-sm font-medium">{event.date}</span>
                </div>

                <h3 className="text-2xl font-bold text-warrior-black mb-3">
                  {event.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-6 flex-grow">
                  {event.description}
                </p>

                {event.registerLink ? (
                  <a
                    href={event.registerLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-warrior-red hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                  >
                    Register Now
                    <i className="ri-external-link-line text-lg"></i>
                  </a>
                ) : (
                  <button
                    onClick={handleLearnMore}
                    className="w-full bg-warrior-red hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleLearnMore}
            className="inline-flex items-center gap-2 text-warrior-red hover:text-red-700 font-semibold text-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            View All Events & Activities
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}